import { useSelector } from "react-redux";
import TableHeaderCell from "../../common/table/tableHeaderCell";
import { t } from "i18next";
import { useAppDispatch } from "../../../redux";
import {
  getSurveyList,
  updateOrder,
  updateOrderAs,
  updatePage,
} from "../../../redux/reducer/surveyReducer";
import { onClickOrder } from "../../../utils/helpers";

const TableHeader = () => {
  const dispatch = useAppDispatch();

  const { surveys } = useSelector((state: any) => state);
  const { order, orderAs } = surveys;

  const OnClickOrder = async (orderType: string) => {
    const { orderOption, listOrderAs } = onClickOrder(
      order,
      orderAs,
      orderType
    );
    dispatch(updateOrder(orderOption));
    dispatch(updateOrderAs(listOrderAs));
    dispatch(updatePage(1));
    dispatch(getSurveyList());
  };

  const getIcon = (orderType: String) => {
    let icon = "unfold_more";

    if (order === orderType) {
      if (orderAs === "desc") {
        icon = "keyboard_arrow_up";
      } else {
        icon = "keyboard_arrow_down";
      }
    }
    return icon;
  };

  return (
    <thead>
      <tr>
        <TableHeaderCell
          icon={getIcon("campaign")}
          onClickOrder={() => {
            OnClickOrder("campaign");
          }}
          className="regionalCodeWidth"
          label={t("campaign")}
        />
        <TableHeaderCell
          icon={getIcon("name")}
          onClickOrder={() => {
            OnClickOrder("name");
          }}
          label={t("headerSection.question")}
        />

        <TableHeaderCell />
      </tr>
    </thead>
  );
};

export default TableHeader;
